import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import InfiniteGallery from '@/components/InfiniteGallery';
import { useBackgroundColor } from '@/providers/BackgroundColorProvider';

const Work: React.FC = () => {
    const { setBackgroundColor } = useBackgroundColor();

    useEffect(() => {
        setBackgroundColor('#fff');
        return () => {
            setBackgroundColor('#000');
        };
    }, [setBackgroundColor]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                paddingTop: { xs: 2, md: 4 },
                paddingBottom: { xs: 2, md: 4 },
                marginTop: '64px',
                width: '100%'
            }}
        >
            {/* <Box
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h3"
                        component="h2"
                        gutterBottom
                        sx={{
                            fontWeight: 'light',
                            marginBottom: 2
                        }}
                    >
                        {t('our_work')}
                    </Typography>

                    <Typography
                        variant="h6"
                        component="h3"
                        gutterBottom
                        sx={{
                            fontWeight: 300,
                            color: 'text.secondary'
                        }}
                    >
                        {t('our_work_description')}
                    </Typography>
                </Box> */}

            <InfiniteGallery />
        </Box>
    );
};

export default Work;
